module.exports = __webpack_public_path__ + "img/sv.38ea88d.svg";